import { post } from '../helpers/fetchServicesMethods';
import { url } from '../reducers/url';

async function logout() {
    try {
        let urlParam = url.logout;
        return await post(urlParam)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                //toast.error('A');
                console.log("error::", error);

                // return dispatch(loginError(error));
                // dispatch(showMessage({ message: error }));
            });
    } catch (error) {
        console.error(error);
    }

}
const LogoutService = {
    logout
};

export default LogoutService;
